import { ServerSubstitutionKeywordsStringAssets } from "../../../../../assets/stringAssets";
import { generateStandardEmailClosingPlainText, generateStandardEmailOpeningPlainText } from "../commonEmailBodyFragments";

/**
 * @function generateEmailBodyPlainTextForSigninWithEmailLink. Generates the Html body of a notification email for a sign-in with email link
 * @param {string} emailAddress The email address of the user requesting the sign-in with email link.
 * @param {string} firstName The first name of the user requesting the sign-in with email link.
 * @param {string} lastName The last name of the user requesting the sign-in with email link.
 * @returns {string} A string with the Html body of the email message to be sent.
 */
export function generateEmailBodyPlainTextForSigninWithEmailLink(emailAddress: string, firstName: string, lastName: string): string {

  const recipientUserName: string = `${firstName} ${lastName}`;

  // *** Compose the email Body in Plain Text format ***
  // salutation/greetings to the recipient
  let emailBodyPlainText = generateStandardEmailOpeningPlainText(recipientUserName);
 
  // inform about sign-in with email link
  emailBodyPlainText += `We have received a request to permit signing into ${ServerSubstitutionKeywordsStringAssets.ProjectName} for this email account (${emailAddress}) using an email link.`;
  emailBodyPlainText += `You may sign-in without a password by clicking on the sign-in link that follows: \n`;
  emailBodyPlainText += `${ServerSubstitutionKeywordsStringAssets.SignInWithEmailLink} \n\n`;
  emailBodyPlainText += `Clicking on the link will re-direct you to a browser and automatically sign you into ${ServerSubstitutionKeywordsStringAssets.ProjectName}. \n\n`;

  emailBodyPlainText += `If you did not request this sign-in link, you can safely ignore this email.\n\n`;

  emailBodyPlainText += `We hope you enjoy using ${ServerSubstitutionKeywordsStringAssets.ProjectName}! \n\n`;

  emailBodyPlainText += generateStandardEmailClosingPlainText();

  // return the email content
  return emailBodyPlainText;
}
